import { Component } from '@angular/core';

@Component({
    selector: 'app-sales-team-dashboard',
    templateUrl: './sales-team-reporting.component.html',
    styleUrls: ['./sales-team-reporting.component.scss'],
    standalone: false
})
export class SalesTeamReportingComponent {}
